// extracted by mini-css-extract-plugin
module.exports = {"moreThingContainer":"MoreThing_moreThingContainer__HVhqK","moreThingText":"MoreThing_moreThingText__rltfc","iconMore":"MoreThing_iconMore__DMrqc"};